import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import * as Yup from 'yup'
import { Formik, Form as FormikForm } from 'formik'
import { MdArrowBack } from 'react-icons/md'
import * as forms from '../../../lib/forms'
import Button from '../../commons/Button/Button'
import Text from '../../commons/Text/Text'
import PasswordFieldFormik from '../../commons/Fields/PasswordFieldFormik'
import Link from '../../commons/Link/Link'
import ErrorMessages from '../../commons/Errors/ErrorMessages'
import routes from '../../../config/routes'

export const PASSWORD_FIELD_ID = 'PASSWORD_FIELD_ID'
export const PASSWORD_CONFIRMATION_FIELD_ID = 'PASSWORD_CONFIRMATION_FIELD_ID'

const INITIAL_VALUES = {
  password: '',
  passwordConfirmation: ''
}

export const VALIDATION_MESSAGES = {
  password: {
    format: 'Senha requerido'
  },
  passwordConfirmation: {
    format: 'Confirmação de senha requerido',
    equal: 'Confirmação de senha deve ser igual a senha'
  }
}

export const PasswordSchema = {
  password: Yup.string().required(VALIDATION_MESSAGES.password.format)
}

export const PasswordConfirmationSchema = {
  passwordConfirmation: Yup.string()
    .required(VALIDATION_MESSAGES.passwordConfirmation.format)
    .oneOf(
      [Yup.ref('password'), null],
      VALIDATION_MESSAGES.passwordConfirmation.equal
    )
}

export const RecoveryPasswordSentPasswordSchema = Yup.object().shape({
  ...PasswordSchema,
  ...PasswordConfirmationSchema
})

const RecoveryPasswordSentPasswordForm = (props) => {
  const { handleSubmit, error } = props

  return (
    <Formik
      enableReinitialize
      initialValues={INITIAL_VALUES}
      validationSchema={RecoveryPasswordSentPasswordSchema}
      onSubmit={handleSubmit}
    >
      {({ isSubmitting, isValid, setErrors, values }) => {
        const disabled = isSubmitting || !isValid

        useEffect(() => {
          forms.applyGeneralError(error?.hasError, values, setErrors)
        }, [error?.hasError, isSubmitting])

        return (
          <FormikForm>
            <PasswordFieldFormik
              id={PASSWORD_FIELD_ID}
              name="password"
              validate="password"
              label="Digite uma senha"
              showRules
            />

            <PasswordFieldFormik
              id={PASSWORD_CONFIRMATION_FIELD_ID}
              name="passwordConfirmation"
              label="Confirme a senha"
            />

            <ErrorMessages error={error} />

            <div
              style={{
                display: 'flex',
                alignItems: 'center'
              }}
            >
              <Link to={routes.resetPasswordSentEmail.path}>
                <Button
                  type="outlined_dark"
                  margin="12px 24px 0px 0px"
                  buttonType="button"
                  width="163px"
                >
                  <MdArrowBack />
                  <Text
                    font="custom"
                    color="gray"
                    variation="dark"
                    size="xs"
                    value="Voltar"
                    margin="0px 0px 0px 13px"
                    bold
                  />
                </Button>
              </Link>

              <Button
                type="secondary"
                margin="12px 0 0"
                buttonType="submit"
                disabled={disabled}
                width="163px"
              >
                <Text
                  font="custom"
                  color="white"
                  size="xs"
                  value="Confirmar"
                  bold
                />
              </Button>
            </div>
          </FormikForm>
        )
      }}
    </Formik>
  )
}

RecoveryPasswordSentPasswordForm.defaultProps = {
  handleSubmit: null,
  error: {
    hasError: false,
    messages: []
  }
}

RecoveryPasswordSentPasswordForm.propTypes = {
  handleSubmit: PropTypes.func,
  error: PropTypes.shape({
    hasError: PropTypes.bool,
    messages: PropTypes.arrayOf(PropTypes.string)
  })
}

export default RecoveryPasswordSentPasswordForm
